import { useEffect } from "react";
import { extractTableFromUrl, cleanUrlRemovingTableParam } from "./urlTable";
import { useOrder } from "../state/order";

export function UrlTableBootstrap() {
  const setBoth = useOrder((s) => s.setBoth);
  useEffect(() => {
    const tableFromUrl = extractTableFromUrl(window.location);

    if (tableFromUrl) {
      setBoth(tableFromUrl, 1);

      cleanUrlRemovingTableParam();
    } else {
      const saved = Number(localStorage.getItem("table"));
      if (saved && isFinite(saved) && saved > 0) setBoth(saved, 1);
    }
  }, []);

  return null;
}
